import { Inject, inject, Injectable, Injector } from '@angular/core';
import { ApolloCache, ApolloClientOptions, ApolloLink, InMemoryCache, NormalizedCacheObject } from '@apollo/client/core';
import { HeaderService } from './header.service';
import { HttpLink } from 'apollo-angular/http';
import { HttpClient } from '@angular/common/http';
import { GraphqlErrorInterceptor } from '../models/graphql-interface.model';
import { setContext } from '@apollo/client/link/context';
class VoidCache extends ApolloCache<NormalizedCacheObject> {
  read(options: any) { return null; }
  write(options: any) { return undefined; }
  diff(options: any) { return {}; }
  watch(watch: any) { return () => { }; }
  async reset() { } // eslint-disable-line
  evict(options: any) { return false; }
  restore(data: any) { return this; }
  extract(optimistic: any) { return {}; }
  removeOptimistic(id: any) { }
  override batch(options: any) { return undefined as any; }
  performTransaction(update: any, optimisticId: any) { }
  override recordOptimisticTransaction(transaction: any, optimisticId: any) { }
  override transformDocument(document: any) { return document; }
  override transformForLink(document: any) { return document; }
  override identify(object: any) { return undefined; }
  override gc() { return [] as string[]; }
  override modify(options: any) { return false; }
  override readQuery(options: any, optimistic?: any) { return null; }
  override readFragment(options: any, optimistic?: any) { return null; }
  override writeQuery(opts: any) { return undefined; }
  override writeFragment(opts: any) { return undefined; }
  override updateQuery(options: any, update: any) { return null; }
  override updateFragment(options: any, update: any) { return null; }
}
@Injectable({
  providedIn: 'root'
})
export class GraphqlConfigService {
  httpClient = inject(HttpClient);
  headerService: HeaderService = inject(HeaderService);
  constructor(
    @Inject('environment') private environment: any,
  ) {
  }

  createApollo(serviceClass: GraphqlErrorInterceptor, graphqlUri?: string, cacheNeeded: boolean = false) {
    const headerLink = setContext((operation, previousContext) => {
      const globalHeaders = this.headerService.getHeaders(); // global headers from your service
      const contextHeaders = previousContext['headers'] || {};  // headers passed per request
      // Merge both
      const finalHeaders = {
        ...globalHeaders,
        ...contextHeaders
      };


      return {
        headers: finalHeaders
      };
    });
    const errors = serviceClass.apolloError();
    // Create HttpLink
    const httpLink = new HttpLink(this.httpClient).create({ uri: graphqlUri });
    // Concatenate headers if available
    const link = ApolloLink.from([errors, headerLink, httpLink]);

    return { link, cache: cacheNeeded ? new InMemoryCache({ addTypename: false }) : new VoidCache() };
   // return { link, cache: cacheNeeded ? new InMemoryCache() : new VoidCache(), addTypename: false };
  }
}
